/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CommitSavedCommoditiesUploadRequest,
  PreviewSavedCommoditiesUploadRequest,
  SavedCommoditiesCommitResult,
  SavedCommoditiesPreviewResult,
  SavedCommoditiesTemplateResponse,
} from "../models/index";
import {
  CommitSavedCommoditiesUploadRequestFromJSON,
  CommitSavedCommoditiesUploadRequestToJSON,
  PreviewSavedCommoditiesUploadRequestFromJSON,
  PreviewSavedCommoditiesUploadRequestToJSON,
  SavedCommoditiesCommitResultFromJSON,
  SavedCommoditiesCommitResultToJSON,
  SavedCommoditiesPreviewResultFromJSON,
  SavedCommoditiesPreviewResultToJSON,
  SavedCommoditiesTemplateResponseFromJSON,
  SavedCommoditiesTemplateResponseToJSON,
} from "../models/index";

export interface CommitRequest {
  commitSavedCommoditiesUploadRequest: CommitSavedCommoditiesUploadRequest;
}

export interface PreviewRequest {
  previewSavedCommoditiesUploadRequest: PreviewSavedCommoditiesUploadRequest;
}

/**
 *
 */
export class SavedCommoditiesUploadApi extends runtime.BaseAPI {
  /**
   */
  async commitRaw(
    requestParameters: CommitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SavedCommoditiesCommitResult>> {
    if (requestParameters["commitSavedCommoditiesUploadRequest"] == null) {
      throw new runtime.RequiredError(
        "commitSavedCommoditiesUploadRequest",
        'Required parameter "commitSavedCommoditiesUploadRequest" was null or undefined when calling commit().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/saved-commodities-upload/commit`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CommitSavedCommoditiesUploadRequestToJSON(
          requestParameters["commitSavedCommoditiesUploadRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SavedCommoditiesCommitResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async commit(
    requestParameters: CommitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SavedCommoditiesCommitResult> {
    const response = await this.commitRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async downloadTemplateRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SavedCommoditiesTemplateResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-commodities-upload/template`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SavedCommoditiesTemplateResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadTemplate(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SavedCommoditiesTemplateResponse> {
    const response = await this.downloadTemplateRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async previewRaw(
    requestParameters: PreviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SavedCommoditiesPreviewResult>> {
    if (requestParameters["previewSavedCommoditiesUploadRequest"] == null) {
      throw new runtime.RequiredError(
        "previewSavedCommoditiesUploadRequest",
        'Required parameter "previewSavedCommoditiesUploadRequest" was null or undefined when calling preview().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/saved-commodities-upload/preview`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PreviewSavedCommoditiesUploadRequestToJSON(
          requestParameters["previewSavedCommoditiesUploadRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SavedCommoditiesPreviewResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async preview(
    requestParameters: PreviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SavedCommoditiesPreviewResult> {
    const response = await this.previewRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
